import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./NavBar.css";

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Función para alternar el menú
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav>
      {/* Botón hamburguesa */}
      <button className="hamburger" onClick={toggleMenu}>
        &#9776; {/* Este carácter es el icono de menú hamburguesa */}
      </button>

      {/* Navbar con clase condicional */}
      <ul className={`navbar ${menuOpen ? "open" : ""}`}>
        <li>
          <NavLink exact to="/" activeClassName="active" onClick={toggleMenu}>
            INICIO
          </NavLink>
        </li>
        <li>
          <NavLink exact to="/founders" activeClassName="active" onClick={toggleMenu}>
            FUNDADORES
          </NavLink>
        </li>
        <li>
          <NavLink exact to="/services" activeClassName="active" onClick={toggleMenu}>
            SERVICIOS
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}